export default "__VITE_ASSET__pvgL9t0q__"